// extracted by mini-css-extract-plugin
export default {"addExampleDialogMessage":"UCeoNGUjqy"};